export default "__VITE_ASSET__CazcmugB__"